// This module enriches Shopify product data with Algolia product data

import algoliasearch from 'algoliasearch';
import {baseConfig} from '../config/algolia';
import productPriceTemplate from '../handlebars/algolia/productPrice.handlebars';

const searchEnrichment = () => {

  // const client = algoliasearch('QFXLKG0GNM', '1b07d52eeb252e49beee57d3c606be5c');
  // const index = client.initIndex('PRODUCTS_uat');

  const client = algoliasearch(baseConfig.app_id, baseConfig.search_api_key);
  const index = client.initIndex(baseConfig.index_products);

  const getSkus = () => {
    const skus = [];
    $('[data-product-view][data-sku]').each(function() {
      skus.push($(this).data('sku').toString());
    });
    return skus;
  };

  const updatePromotions = (val) => {

    /* Apply Price Tag */
    if (val && Object.keys(val.pricing).length > 0 && val.pricing.displayPriceInc !== '') {
      const priceTag = productPriceTemplate({pricing: val.pricing, showWasPrice: val.showWasPrice === true});
      // update matching product tile with the correct price
      $(`[data-product-view="product-tile"][data-sku=${val.sku}]`).find('.pricing-block').replaceWith(priceTag);
      // update matching product hero with the correct price
      $(`[data-product-view="product-hero"][data-sku=${val.sku}]`).find('.pricing-block').replaceWith(priceTag);
    }

    /* Apply promo tag */
    if (val && val.promo_tags.length) {
      // Only select top 2 promos
      val.promo_tags.slice(0, 2).forEach((tag) => {
        $(`[data-product-view="product-tile"][data-sku=${val.sku}]`).find('.product-tile').prepend(`
                <div class="promo-tag" style="color:${tag.color}; background:${tag.background_color};">${tag.label}</div>
              `);
        // update matching product hero with the correct promo tag
        $(`[data-product-view="product-hero"][data-sku=${val.sku}]`).find('.product-overview').prepend(`
                <div class="promo-tag" style="color:${tag.color}; background:${tag.background_color};">${tag.label}</div>
              `);
      });
    }

    /* Apply banners */
    if (val && Object.keys(val.banner_tags).length > 0) {
      const wordsArray = val.banner_tags.label.split(/\s+/);
      let words = '';
      wordsArray.forEach((word) => {
        words += `<span>${word}</span> `;
      });
      const className = wordsArray.join('-').toLowerCase();
      // update matching product tile with the correct banner
      $(`[data-product-view="product-tile"][data-sku=${val.sku}]`).find('.product').prepend(`
        <span class="product-banner ${className}" style="background:${val.banner_tags.background_color}; color:${val.banner_tags.color};">${words}</span>
      `);
      // update matching product hero with the correct banner
      $(`[data-product-view="product-hero"][data-sku=${val.sku}]`).find('.product-overview').prepend(`
            <span class="product-banner ${className}" style="background:${val.banner_tags.background_color}; color:${val.banner_tags.color};">${words}</span>
          `);
    }

  };

  const updateProducts = (results) => {
    results.forEach((val) => {
      updatePromotions(val);
    });
  };

  const callAlgolia = async () => {
    const skus = getSkus();
    try {
      if (skus) {
        const response = await index.getObjects(skus);
        if (response.results) {
          updateProducts(response.results);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // with SHIP, we have all product data we need in product.metafields,
  // so no need to call Aloglia any more!!
  //callAlgolia();

};

export default searchEnrichment;
